import React from 'react';
import {getChallengeContainer} from './GenericChallengeContainer.js';


const getSteps = (t) => [
    {type:'Confirm',         props:{buttonText:t('challenges:::What is your count?')}},
    {type:'NumericInput',    props:{placeholder:t('challenges:::What is your count?'), buttonText:t('challenges:::Confirm')},assign:{'value':'value'}, action:function(vars){ return {value:vars.value} }},
];

const InputChallengeContainer = getChallengeContainer(getSteps, '/virtual/input-challenge');

export default InputChallengeContainer;



// WEBPACK FOOTER //
// ./src/modules/challenges/types/InputChallengeContainer.js